
import { Injectable } from '@angular/core';
import { Observable, of, map, catchError } from 'rxjs';
import { Apiv1Service } from '../services/apiv1.service';
import { Router } from '@angular/router';
//import { provideHttpClient, withInterceptors } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class LoginService {
getUserId() {
  throw new Error('Method not implemented.');
}
private storageKey = 'basic_auth_header';

constructor( private store: Apiv1Service, private router: Router) {}

login(username: string, password: string): Observable<boolean> {
const token = btoa(String.fromCharCode(...new TextEncoder().encode(`${username}:${password}`)));
const header = `Basic ${token}`;
return this.store.authenticate(header).pipe(
  map(identity => {
    if (!identity.trim()) {
      this.store.logout();
      return false;
    }
    this.store.login(header);
    return true;
  }),
  catchError(() => {
    this.store.logout();
    return of(false);
  })
);
}

logout() {
  this.store.logout();
  this.reloadRoute();
}
reloadRoute() {
  const currentUrl = this.router.url;
  this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
    this.router.navigate([currentUrl]);
  });
}
getAuthHeader(): string | null {
  return this.store.getAuthHeader();
}

isLoggedIn(): boolean {
  return this.store.isLoggedIn();
}
}